/**
 * Returns a debounced function.
 *
 * Subsequent calls reset the timer; `fn` runs only after `wait` ms
 * have elapsed since the latest call.
 *
 * @param {Function} fn
 * @param {number} wait
 * @returns {Function}
 */
export default function debounce(fn, wait) {
  let timeout_id;

  return (...args) => {
    clearTimeout(timeout_id);
    timeout_id = setTimeout(() => fn(...args), wait);
  };
}
